<template>
  <section class="services-section">
    <div class="container">
      <div class="services-header">
        <p class="services-subtitle">Nos services</p>
        <h2 class="services-title">
          Deux offres pensées pour<br>
          <span class="underline">vos besoins</span>
        </h2>
        <img :src="require('@/assets/img/Vector 384 (4).png')" alt="Décoration" class="services-decoration">
      </div>

      <div class="row services-cards">
        <div class="col-lg-6 col-md-6 mb-4">
          <div class="service-card">
            <div class="service-image">
              <img :src="require('@/assets/img/a449987a803e47a9aacbed43bce440c3a250d7a7 (1).jpg')" alt="N'Lite" class="service-img">
            </div>
            <div class="service-content">
              <div class="service-badge">
                <i class="bi bi-person"></i>
                <span>Pour les particuliers</span>
              </div>
              <h3 class="service-name">N'Lite</h3>
              <p class="service-description">
                Une solution simple pour envoyer et recevoir de l'argent partout, en un clic: Transferts nationale, régionaux, demandes de paiement international...
              </p>
              <a href="#" class="service-link">
                En savoir plus sur N'Lite
                <i class="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 mb-4">
          <div class="service-card">
            <div class="service-image">
              <img :src="require('@/assets/img/a449987a803e47a9aacbed43bce440c3a250d7a7 (2).jpg')" alt="N'Business" class="service-img">
            </div>
            <div class="service-content">
              <div class="service-badge">
                <i class="bi bi-briefcase"></i>
                <span>Pour les professionnels</span>
              </div>
              <h3 class="service-name">N'Business</h3>
              <p class="service-description">
                La plateforme pro pour encaisser, décaisser et gérer vos finances en un seul outil: QR code, API, paiements en masse... tout est simplifié.
              </p>
              <a href="#" class="service-link">
                En savoir plus sur N'Business
                <i class="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServicesSection",
};
</script>

<style scoped>
/* Section Nos Services */
.services-section {
  background: #F8F8F8;
  padding: 100px 0;
  position: relative;
  overflow: hidden;
}

.services-header {
  text-align: center;
  margin-bottom: 4rem;
  position: relative;
}

.services-subtitle {
  font-size: 1rem;
  color: #666;
  margin-bottom: 1rem;
  font-weight: 500;
}

.services-title {
  font-size: 2.75rem;
  font-weight: 800;
  color: #1A1A1A;
  line-height: 1.2;
  margin-bottom: 0;
  letter-spacing: -0.03em;
}

.services-title .underline {
  position: relative;
  display: inline-block;
}

.services-title .underline::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -8px;
  height: 12px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 12'%3E%3Cpath d='M2 6 Q50 2, 100 6 T198 6' stroke='%23F5A847' stroke-width='3' fill='none' stroke-linecap='round'/%3E%3C/svg%3E");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.services-decoration {
  position: absolute;
  top: -50px;
  right: 10%;
  width: 150px;
  height: auto;
  opacity: 0.8;
  z-index: 1;
}

.services-cards {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}

.services-cards > div {
  padding: 0 15px;
}

.service-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.service-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15);
}

.service-image {
  width: 100%;
  height: 280px;
  overflow: hidden;
  position: relative;
}

.service-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.service-card:hover .service-img {
  transform: scale(1.05);
}

.service-content {
  padding: 2rem;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.service-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #F8F8F8;
  padding: 0.5rem 1rem;
  border-radius: 50px;
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 1.25rem;
  width: fit-content;
}

.service-badge i {
  font-size: 1rem;
  color: #F5A847;
}

.service-name {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1A1A1A;
  margin-bottom: 1rem;
}

.service-description {
  font-size: 0.95rem;
  color: #666;
  line-height: 1.7;
  margin-bottom: 1.5rem;
  flex: 1;
}

.service-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #F5A847;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  transition: all 0.3s;
}

.service-link:hover {
  color: #E69535;
  gap: 0.75rem;
}

.service-link i {
  font-size: 1rem;
  transition: transform 0.3s;
}

.service-link:hover i {
  transform: translateX(5px);
}

@media (max-width: 992px) {
  .services-section {
    padding: 60px 0;
  }

  .services-title {
    font-size: 2rem;
  }

  .services-decoration {
    width: 100px;
    right: 5%;
  }

  .service-image {
    height: 240px;
  }
}

@media (max-width: 768px) {
  .services-header {
    margin-bottom: 2.5rem;
  }

  .services-title {
    font-size: 1.75rem;
  }

  .services-decoration {
    display: none;
  }

  .service-image {
    height: 220px;
  }

  .service-content {
    padding: 1.5rem;
  }

  .service-name {
    font-size: 1.5rem;
  }

  .service-description {
    font-size: 0.9rem;
  }
}
</style>
